/**
 * Mapping from common font names to font weights
 *
 * From https://developer.mozilla.org/en-US/docs/Web/CSS/font-weight#common_weight_name_mapping
 */
export const fontWeights = {
    /**
     * Thin / 100
     */
    thin: 100,
    /**
     * Light / 300
     */
    light: 300,
    /**
     * Normal / 400
     */
    normal: 400,
    /**
     * Bold / 700
     */
    bold: 700,
    /**
     * Extral bold / 800
     */
    extraBold: 800,
    /**
     * Black / 900
     */
    black: 900,
};
